import { randomBytes } from 'crypto';
import { SECTION_TYPES } from '@/components/Constructor/constants';

import ConstructorCard from './ConstructorCard';

export default class ConstructorSection {
  /**
   *
   * @param {String} value.title
   * @param {String} value.description
   * @param {Number} value.type
   * @param {Array} value.cards
   *
   * @param {Number} cardsType
   */
  constructor({ value, cardsType } = {
    value: {
      id: null,
      title: 'Новая секция',
      description: null,
      cards: [],
      type: SECTION_TYPES.generic,
    },
  }) {
    this.id = value.id;
    this.hash = randomBytes(20).toString('hex');
    this.cardsType = cardsType;
    this.value = value;

    if (this.value.cards) {
      this.value.cards = this.value.cards.map(
        (v) => new ConstructorCard({ ...v, type: cardsType }),
      );
    }
  }
}
